const AuthFooter = () => {
    return (
        <>
            <div className="d-flex justify-content-center ">
                <div className="col-7 bg-tertiary text-center text-secondary fs-6">
                    <p>&copy; 2024 PlayPal. All Rights Reserved.</p>
                </div>
            </div>
        </>
    )
}

export default AuthFooter;